<template>
    <tr>
        <td>
            <date-picker v-model="invoicePayment.date" valueType="format" format="DD.MM.YYYY"></date-picker>
            <div class="input-error-message" v-if="errors.date">{{errors.date[0]}}</div>
        </td>
        <td>
            <input type="text" class="input w-full" v-model="invoicePayment.sales_tax_percent" placeholder="USt"/>
            <div class="input-error-message" v-if="errors.sales_tax_percent">{{errors.sales_tax_percent[0]}}</div>
        </td>
        <td>
            <currency-input
                    v-model="invoicePayment.amount"
                    currency="EUR"
                    locale="de"
                    class="input w-full"
            />
            <div class="input-error-message" v-if="errors.amount">{{errors.amount[0]}}</div>
        </td>
        <td>
          <input type="checkbox" v-model="invoicePayment.is_refund"> Auslage
        </td>
        <td>
            <button class="btn btn-small btn-secondary mr-4" @click="save()">
                <i class="far fa-plus-square"></i> speichern
            </button>
            <button class="btn btn-small btn-remove" @click="$emit('updated')">
                <i class="far fa-times-circle"></i> abbrechen
            </button>
        </td>
    </tr>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/locale/de';
    import moment from 'moment';

    export default {
        props: ['initialData', 'invoiceId'],
        data: function() {
            return {
                invoicePayment: this.initialData || {},
                errors: [],
                saveMethod: this.newRecord() ? 'post' : 'put',
                saveUrl: this.newRecord() ? '/invoice_payments/' : '/invoice_payments/' + this.initialData.id,
            }
        },
        methods: {
            newRecord: function() {
                if (this.initialData) {
                    return false;
                }
                return true;
            },
            save: function() {
                this.$http[this.saveMethod](this.saveUrl, {
                    invoice_payment: this.invoicePayment
                }).then(response => {
                    this.$emit('updated')
                    this.$forceUpdate()
                }, response => {
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            },
        },
        mounted() {
            if (this.newRecord()) {
                this.invoicePayment.invoice_id = this.invoiceId
                this.invoicePayment.sales_tax_percent = 19
                this.invoicePayment.date = moment().format("DD.MM.YYYY");
                this.$forceUpdate()
            } else {
                this.invoicePayment.date = moment(this.initialData.date, "YYYY-MM-DD").format("DD.MM.YYYY");
            }
        },
    }
</script>